module.exports = __webpack_public_path__ + "img/03.906315b7.png";